var map = {
	"./black/guanbihuiyi.png": "0sG3",
	"./blue/guanbihuiyi.png": "rj7i",
	"./white/guanbihuiyi.png": "lBkt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KWpy";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/guanbihuiyi\.png$
// module id = KWpy
// module chunks = 24